// Lib
import React from 'react';
import FAQCollapsibleCard from '../../../components/Support/FAQCollapsibleCard/FAQCollapsibleCard';
import { useInfiniteHits } from 'react-instantsearch-hooks-web';
import InfiniteScroll from 'react-infinite-scroll-component';

// Components
import TotalQtyLabel from '../../../components/Labels/TotalQtyLabel';

// Styles
import { useStyles } from './FAQPageStyles';

const FAQPage = ({ isMobileMode }) => {
  const { hits, results, showMore, isLastPage } = useInfiniteHits();

  const { classes } = useStyles({ isMobileMode });

  return (
    <>
      <TotalQtyLabel
        qty={results.nbHits}
        type={'item'}
        className={classes.kitsQtyLabel}
      />
      <InfiniteScroll
        dataLength={hits.length}
        next={showMore}
        hasMore={!isLastPage}
        className={classes.list}>
        {hits.map((item, index) => (
          <FAQCollapsibleCard key={item.objectID || index} item={item} />
        ))}
      </InfiniteScroll>
    </>
  );
};

export default FAQPage;
